import script from "./ShopInfoDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShopInfoDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./ShopInfoDrawer.vue?vue&type=style&index=0&id=18dece86&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18dece86"]])

export default __exports__